(function ($) {
    var facetFlag = false;
    var coveoResultsPerCall = 10;
    var totalResults;
    var seeAllResCount = 10;
    var dateAscText, dateDescText, viewLessTxt, viewMoreTxt, postDateSortCriteria, dateSortCriteria, sortBylabel;
    var dateSort;
    var showDateDrpdown = false;
    var seeAllClicked = false;
    var seeLessClicked = false;
    var seeAllClickedFirst = false;
    init();

    function init() {
        if (($('.coveo-new-ui').length) && (!$('.enhanced-result-list').length)) {
            dateAscText = document.querySelector(".showMoreResults").getAttribute("data-date-asc");
            dateDescText = document.querySelector(".showMoreResults").getAttribute("data-date-desc");
            viewMoreTxt = document.querySelector(".showMoreResults").getAttribute("data-view-all");
            viewLessTxt = document.querySelector(".showMoreResults").getAttribute("data-view-less");
            seeAllResCount = document.querySelector(".showMoreResults").getAttribute("data-result-count");
            sortBylabel = document.querySelector(".showMoreResults").getAttribute("data-sort-by");
            if (document.querySelector(".CoveoSort") != null) {
                if (JSON.parse(document.querySelector(".CoveoSort").getAttribute('data-sort-criteria')).field) {
                    postDateSortCriteria = JSON.parse(document.querySelector(".CoveoSort").getAttribute('data-sort-criteria')).field.toLowerCase();
                }
            }
            if (document.querySelector(".CoveoSort") != null) {
                if (JSON.parse(document.querySelector(".CoveoSort").getAttribute('data-sort-criteria')).type) {
                    dateSortCriteria = JSON.parse(document.querySelector(".CoveoSort").getAttribute('data-sort-criteria')).type.toLowerCase();
                }
            }
            if ($('.CoveoSort').length && (postDateSortCriteria === 'posted date' || dateSortCriteria === 'date')) {
                showDateDrpdown = true;
            }
            $(".coveo-querysummary").remove();
            if (showDateDrpdown) {
                //@postedz32xdate
                if ($('.CoveoSort').length && postDateSortCriteria === 'posted date') {
                    $(".coveo-sort-container").remove();
                    $('<div class="wrap-div-float"><div class="my-auto pe-3"><span>' + sortBylabel + '</span></div><div class="custom-date-sort" tabindex="0"><div class="date-selected-sorting"><span>' + dateDescText + '</span> <i class="fa fa-angle-down"></i></div> <div class="coveo-sort-section  coveo-dateSort" style="display:none;"> <span class="CoveoSort" data-sort-criteria="@postedz32xdate descending" data-caption="' + dateDescText + '"></span> <span class="CoveoSort" data-sort-criteria="@postedz32xdate ascending" data-caption=" ' + dateAscText + '"></span></div></div></div>').insertBefore('.coveo-resultslist');
                } else {
                    $(".coveo-sort-container").remove();
                    $('<div class="wrap-div-float"><div class="my-auto pe-3"><span>' + sortBylabel + '</span></div><div class="custom-date-sort" tabindex="0"><div class="date-selected-sorting"><span>' + dateDescText + '</span> <i class="fa fa-angle-down"></i></div> <div class="coveo-sort-section  coveo-dateSort" style="display:none;"> <span class="CoveoSort" data-sort-criteria="date descending" data-caption="' + dateDescText + '"></span> <span class="CoveoSort" data-sort-criteria="date ascending" data-caption=" ' + dateAscText + '"></span></div></div></div>').insertBefore('.coveo-resultslist');
                }
            }
            $(".coveo-resultslist").append('<div class="text-end result-list-paging"><a  class="seeallList" tabindex="0" role="button">' + viewMoreTxt + '</a><a  class="seeLessList" tabindex="0" role="button">' + viewLessTxt + '</a><span class="pipe-divider"> | </span><span class="CoveoQuerySummary"></span><div class="CoveoPager"></div> </div>');
            $('.seeLessList').css('display', 'none');
        }
        $(document).ready(onDomReady);

        // $(window).on('load', onWindowLoad);
    }
    // chemical clear all facets
    $(".clearallfacets").click(function (e) {
        var url = new URL(location.href);
        if (url.href.includes("f:"))
            window.location.href = url.href.substring(0, url.href.indexOf("f:") + 1);
        return false;
    });

    function onWindowLoad() {
        var cookiename = 'Exxon-last-searches';
        ToggelLastSearch(cookiename);
        applyProcurementInitialState();
        addButtonLabel();
        addButtonLabelEvents();
        bindPageLoadEvents();
        populateShowFacetTexts('load');
        showTenResults();
        triggeringClickOnKeyPress();
        addSearchButtonLabel();
        addGoToGlobalSearch();
        toggleFacetShowMoreLess();
        appendIndexId();
    }

    $(window).on('load', function () { addSearchRole(); });

    $(document).ready(function () {
        appendIndexId();
    });

    function appendIndexId() {
        if ($(".coveo-magicbox-suggestions").length > 1) {
            $(".coveo-magicbox-suggestions").each(function (index) {
                if ($(this).attr("id") == "coveo-magicbox-suggestions" || $(this).attr("id") == "owned_listbox") {
                    var elementId = $(this).attr("id");
                    var id = elementId + index;
                    $(this).attr("id", id);
                }
            });
        }
    }

    function addSearchRole() {
        setTimeout(function () {
            $(".body-content .CoveoOmnibox").removeAttr('role');
            $(".body-content .CoveoOmnibox").removeAttr('aria-expanded');
            var coveosearchInput = $(".body-content .magic-box-input > input");
            var suggestedItems = coveosearchInput.parents().find($(".magic-box-suggestions"));
            $(".magic-box-suggestions > div").attr("aria-label", "search suggestions");
            $(".magic-box-suggestions > div.coveo-magicbox-suggestions").attr("role", "list");
            if ($(".magic-box-suggestions > div.coveo-magicbox-suggestions > div")) {
                $(".magic-box-suggestions > div.coveo-magicbox-suggestions > div").each(function () {
                    $(this).attr("role", "listitem");
                });
            }
            if ($('.coveo-sort-container')) {
                $('.coveo-sort-container span.CoveoSort.coveo-accessible-button').removeAttr('tabindex');
            }

            /*  if($('.CoveoSearchInterface .coveo-searchbox .CoveoOmnibox').length){
                $('.CoveoSearchInterface .coveo-searchbox .CoveoOmnibox').attr('role','combobox');
            } */

            //Bug 82565: Mobil-Events coveo Search-NVDA is announced with combo box collapsed when focus to the search input field which does not have the suggestion list to show

            coveosearchInput.attr("role", "combobox");
            coveosearchInput.attr("aria-haspopup", "listbox");
            coveosearchInput.attr("aria-owns", "owned_listbox");
            coveosearchInput.attr("aria-expanded", "false");
            coveosearchInput.on("blur", function () {
                coveosearchInput.attr("aria-expanded", "false");
            });
            appendIndexId();
            coveosearchInput.on("focus", function () {
                setTimeout(function () {
                    if ($(".body-content .magic-box.magic-box-hasFocus").hasClass("magic-box-notEmpty")) {
                        if (suggestedItems.hasClass("magic-box-hasSuggestion")) {
                            coveosearchInput.attr("aria-expanded", "true");
                        } else {
                            coveosearchInput.attr("aria-expanded", "false");
                        }
                    } else {
                        coveosearchInput.attr("aria-expanded", "false");
                    }
                }, 1000);
            });
            coveosearchInput.on("keyup", function () {
                $(".magic-box-suggestions > div").attr("role", "list");
                $(".magic-box-suggestions > div").attr("id", "owned_listbox");
                $(".magic-box-suggestions > div").attr("aria-label", "search suggestions");
                $(".magic-box-suggestions > div > div").each(function () {
                    $(this).attr("aria-label", $(this).text());
                    $(this).attr("role", "listitem");
                });
                appendIndexId();
                setTimeout(function () {
                    if ($(".body-content .magic-box.magic-box-hasFocus").hasClass("magic-box-notEmpty")) {
                        if (suggestedItems.hasClass("magic-box-hasSuggestion")) {
                            coveosearchInput.attr("aria-expanded", "true");
                        } else {
                            coveosearchInput.attr("aria-expanded", "false");
                        }
                    } else {
                        coveosearchInput.attr("aria-expanded", "false");
                    }
                }, 1000);
            });
            coveosearchInput.on("keypress", function () {
                $(".magic-box-suggestions > div").attr("role", "list");
                $(".magic-box-suggestions > div").attr("aria-label", "search suggestions");
                $(".magic-box-suggestions > div").attr("id", "owned_listbox");
                $(".magic-box-suggestions > div > div").each(function () {
                    $(this).attr("aria-label", $(this).text());
                    $(this).attr("role", "listitem");
                });
                appendIndexId();
                setTimeout(function () {
                    if ($(".body-content .magic-box.magic-box-hasFocus").hasClass("magic-box-notEmpty")) {
                        if (suggestedItems.hasClass("magic-box-hasSuggestion")) {
                            coveosearchInput.attr("aria-expanded", "true");
                        } else {
                            coveosearchInput.attr("aria-expanded", "false");
                        }
                    } else {
                        coveosearchInput.attr("aria-expanded", "false");
                    }
                }, 1000);
            });

            coveosearchInput.on("keydown", function () {
                $(".magic-box-suggestions > div").attr("role", "list");
                $(".magic-box-suggestions > div").attr("aria-label", "search suggestions");
                $(".magic-box-suggestions > div").attr("id", "owned_listbox");
                $(".magic-box-suggestions > div > div").each(function () {
                    $(this).attr("aria-label", $(this).text());
                    $(this).attr("role", "listitem");
                });
                appendIndexId();
                setTimeout(function () {
                    if ($(".body-content .magic-box.magic-box-hasFocus").hasClass("magic-box-notEmpty")) {
                        if (suggestedItems.hasClass("magic-box-hasSuggestion")) {
                            coveosearchInput.attr("aria-expanded", "true");
                        } else {
                            coveosearchInput.attr("aria-expanded", "false");
                        }
                    } else {
                        coveosearchInput.attr("aria-expanded", "false");
                    }
                }, 1000);
            });
            // $(".body-content .event-section .magic-box-input > input").removeAttr("role");
            $(".body-content .event-section .magic-box-input > input").removeAttr("aria-haspopup");
            $(".body-content .event-section .magic-box-input > input").removeAttr("aria-owns");
            // $(".body-content .events-search .magic-box-input > input").removeAttr("role");
            $(".body-content .events-search .magic-box-input > input").removeAttr("aria-haspopup");
            $(".body-content .events-search .magic-box-input > input").removeAttr("aria-owns");
        }, 1800);
    }
    function triggeringClickOnKeyPress() {
        seeAllClicked = false;
        seeLessClicked = false;
        $('.seeLessList').css('display', 'none');
        if ($('.seeallList').length) {
            $('.seeallList').css('display', 'inline-block');
        }
        if ($('.pipe-divider').length) {
            $('.pipe-divider').css('display', 'inline-block');
        }
        if ($('.coveo-pager-next').length) {
            $('.coveo-pager-next').css('display', 'inline-block');
        }
        if ($('.coveo-pager-previous').length) {
            $('.coveo-pager-previous').css('display', 'inline-block');
        }
        if (typeof Coveo === 'undefined' || !$('.coveo-searchinterface .CoveoSearchInterface').length) return;
        Coveo.$(".CoveoSearchInterface .coveo-searchbox .CoveoSearchbox input").on('keydown', function (e) {
            if (e.keyCode == 13) {
                $(this).parents('.CoveoSearchbox').trigger('SearchBoxSearch'); // this is required for analytics tracking
                var inputText = Coveo.$(".CoveoSearchbox .magic-box-input").text();
                if (inputText.replace(/[-_;()]/gi, ' ').trim().replace(/[!%'"#<>\{\}\\\/]/gi, '') != '') {
                    navigateToSearchResults(inputText);
                    if ($('.CoveoSearchInterface .col-lg-3').css('display') == 'none' && !$('.CoveoSearchInterface .col-lg-3.no-result').length) {
                        $('.CoveoSearchInterface .col-lg-3').css('display', 'block');
                    }
                    if ($('.CoveoSearchInterface .col-lg-9 p').css('display') == 'none') {
                        $('.CoveoSearchInterface .col-lg-9 p').css('display', 'block');
                    }
                    if ($('.CoveoSearchInterface #A05Searchbox_Recentsearch').css('display') == 'none' && hasCoveoCookieConsent()) {
                        $('.CoveoSearchInterface #A05Searchbox_Recentsearch').css('display', 'block');
                    }
                    if ($('.CoveoSearchInterface .search-suggestions').css('display') == 'none') {
                        $('.CoveoSearchInterface .search-suggestions').css('display', 'block');
                    }
                    if ($('.CoveoSearchInterface.ils .col-lg-9').css('display') == 'none') {
                        $('.CoveoSearchInterface.ils .col-lg-9').css('display', 'block');
                    }
                    UpdateSearchHeaderLabel();
                    showResultsPDS();
                }
            }
        });
    }

    function addButtonLabel() {
        searchButton = $('.CoveoSearchInterface .coveo-searchbox .CoveoSearchbox .CoveoSearchButton');
        buttonLabel = searchButton.attr('aria-label');

        if ($('.coveoSearchLabel').length) {
            buttonLabel = $('.coveoSearchLabel').attr('data-field-searchlabel');
        }

        if ($('.enhanced-chem-search').length) {
            searchButton.html(`
                <picture>
                    <source media="(max-width:379px)" srcset="/-/media/project/wep/shared/icon-library/others/search-icon.svg" height="16" width="16">
                    <source media="(min-width:480px) and (max-width:719px)" srcset="/-/media/project/wep/shared/icon-library/others/search-icon.svg" height="16" width="16">
                    <source media="(min-width:1024px)" srcset="/-/media/project/wep/shared/icon-library/others/search-icon.svg" height="16" width="16">
                    <img src="/-/media/project/wep/shared/icon-library/others/search-icon.svg" alt="${buttonLabel}">
                </picture>
                <span class="visually-hidden">${buttonLabel}</span>
            `);
        } else searchButton.text(buttonLabel);

        addAriaLabelToSearch();
    }

    (function () {
        const cleanHash = (rawHash) => {
            const hash = rawHash.startsWith('#') ? rawHash.substring(1) : rawHash;
            const params = new URLSearchParams(hash);

            if (params.has('t')) {
                params.delete('t');

                const entries = [];
                for (const [key, value] of params.entries()) {
                    entries.push(`${key}=${value}`);
                }

                return '#' + entries.join('&').replace(/\+/g, '%20');
            }

            return rawHash;
        };

        // 1. Handle hashchange
        window.addEventListener('hashchange', function () {
            const cleaned = cleanHash(location.hash);
            if (location.hash !== cleaned) {
                history.replaceState(null, '', cleaned);
            }
        });

        // 2. Override pushState
        const originalPushState = history.pushState;
        history.pushState = function (state, title, url) {
            if (typeof url === 'string' && url.includes('#')) {
                const [path, hashPart] = url.split('#');
                const cleanedHash = cleanHash('#' + hashPart);
                url = path + cleanedHash;
            }
            return originalPushState.apply(this, [state, title, url]);
        };

        // Optional: Also override replaceState
        const originalReplaceState = history.replaceState;
        history.replaceState = function (state, title, url) {
            if (typeof url === 'string' && url.includes('#')) {
                const [path, hashPart] = url.split('#');
                const cleanedHash = cleanHash('#' + hashPart);
                url = path + cleanedHash;
            }
            return originalReplaceState.apply(this, [state, title, url]);
        };
    })();

    // accessibility form elements are has no programatically associated labels
    function addAriaLabelToSearch() {
        // accessibility form elements are has no programatically associated labels
        setTimeout(function () {
            addSearchRole();
            $('.magic-box-input').find('input').attr('enterkeyhint', 'go');
            var searchBtnText = $('.CoveoSearchInterface .CoveoSearchbox .CoveoSearchButton');
            var buttonLabelText = searchBtnText.attr('aria-label');
            var footerSearch = $('.footer-search-social .coveo-globalsearchbox .CoveoSearchInterface .CoveoSearchbox .CoveoSearchButton');
            if (footerSearch) {
                $('.footer-search-social .coveo-globalsearchbox .CoveoSearchInterface .CoveoSearchbox .CoveoSearchButton').attr('role', 'button');
            }
            if (buttonLabelText) {
                $('input[form="coveo-dummy-form"]').attr('aria-label', buttonLabelText);
            }
            $('.coveo-searchinterface .CoveoSearchbox .CoveoOmnibox').attr('aria-label', buttonLabelText);

            //  $('.coveo-searchinterface .CoveoSearchbox .CoveoOmnibox').removeAttr('role');
            if ($('.CoveoSearchInterface .coveo-searchbox .CoveoOmnibox').length) {
                //     $('.CoveoSearchInterface .coveo-searchbox .CoveoOmnibox').removeAttr('role');
                $('.CoveoSearchInterface .coveo-searchbox .CoveoOmnibox').removeAttr('aria-haspopup');
                $('.CoveoSearchInterface .coveo-searchbox .CoveoOmnibox').removeAttr('aria-expanded');
            }
            if ($('.coveo-globalsearchbox .CoveoSearchInterface .CoveoOmnibox').length) {
                //     $('.coveo-globalsearchbox .CoveoSearchInterface .CoveoOmnibox').removeAttr('role');
                $('.coveo-globalsearchbox .CoveoSearchInterface .CoveoOmnibox').removeAttr('aria-haspopup');
                $('.coveo-globalsearchbox .CoveoSearchInterface .CoveoOmnibox').removeAttr('aria-expanded');
            }

            $('.footer-search-social .coveo-globalsearchbox .CoveoSearchbox .CoveoOmnibox').attr('aria-label', $('.footer-search-social .coveo-globalsearchbox .CoveoSearchInterface .CoveoSearchbox .CoveoSearchButton').attr('aria-label'));
            $('.footer-search-social .coveo-globalsearchbox .CoveoSearchbox .CoveoOmnibox').attr('aria-label', 'combobox');
        }, 1000);
    }

    function addButtonLabelEvents() {
        if (!$('.detail-search').length) return;
        searchButton = $('.detail-search .CoveoSearchInterface .CoveoSearchbox .CoveoSearchButton');
        buttonLabel = $('.detail-search').data('search-label');
        searchButton.text(buttonLabel);
        addAriaLabelToSearch();
    }
    $(window).on('load', addSearchButtonLabel);
    function addSearchButtonLabel() {
        String.toLocaleString({
            "ko": {
                "ShowingResultsOfWithQuery": "결과 {0},{2} 중<pl>-{1}</pl>" // Overrides an existing string.
            }
        });
        if (!$('.coveo-globalsearchbox').length) return;
        searchButtonGlobal = $('.CoveoSearchInterface .coveo-globalsearchbox .CoveoSearchbox .CoveoSearchButton');
        buttonLabel = searchButtonGlobal.attr('aria-label');
        searchButtonGlobal.text(buttonLabel);
        // to remove clear button in header coveo
        $('.nav-header .nav-main-search .magic-box .magic-box-clear').removeAttr('tabindex').addClass('d-none');

        if ($('main .coveo-globalsearchbox .CoveoSearchbox .CoveoSearchButton').length) {
            searchButtonGlMain = $('main .coveo-globalsearchbox .CoveoSearchbox .CoveoSearchButton');
            buttonLabelG = searchButtonGlMain.attr('aria-label');
            searchButtonGlMain.text(buttonLabelG);
        }
        addAriaLabelToSearch();
    }
    function addGoToGlobalSearch() {
        if (!$('.coveo-globalsearchbox').length) return;

        $(".coveo-globalsearchbox").each(function (index) {
            var searchLabel = $(this).find('.SearchLabel');
            if (searchLabel.length > 0) {
                var buttonLabelText = searchLabel.attr('data-field-searchlabel');
                var searchButtonGlobal = $(this).find('.CoveoSearchbox .CoveoSearchButton');
                searchButtonGlobal.text(sanitizeHtmlStrings(buttonLabelText));
                searchButtonGlobal.attr("aria-label", buttonLabelText);
            }
        });
        addAriaLabelToSearch();
    }


    function removeCoveoMinHeight() {
        var $component = $('.component.coveo-searchinterface');
        if ($component.length) {
            $component.css('min-height', '0');
        }
    }

    function applyProcurementInitialState() {
        // for procurement search -- mergerd from chemicals
        if (Coveo.$(".coveo-searchinterface .procurement-search").length && !Coveo.$(".coveo-searchinterface .procurement-search .CoveoSearchbox .magic-box-input input").val())
            $(".noresults").hide();
        $(".procurement-search .procurement-default-search").hide();
        removeCoveoMinHeight();

    }

    function UpdateSearchHeaderLabel(searchedQueryText) {
        var input = Coveo.$(".coveo-searchinterface .CoveoSearchbox .magic-box-input input");
        if (input.length) {
            var searchWord = searchedQueryText ? searchedQueryText.trim() : input.val().trim() === '' ? '' : "'" + input.val() + "'";
            var isBestBetsAvailable = false;
            if ($("#SearchSuggestion").length) {
                var bestBetsArray = JSON.parse($("#SearchSuggestion").attr("data-app-searchconfig"));
                for (var i = 0; i < bestBetsArray.length; i++) {
                    var trimmedText = input.val().trim().toUpperCase();
                    if (trimmedText.length && trimmedText.indexOf(bestBetsArray[i].SearchKey.toUpperCase()) > -1) {
                        isBestBetsAvailable = true;
                    }
                }
            }
            if (searchWord === "" || !isBestBetsAvailable) {
                $(".search-suggestions").hide();
            }
            else {
                $(".search-suggestions").show();
            }
            if (searchWord === "" || document.location.href.indexOf("#q") < 0) {
                $('.search-word').empty();
                return false;
            }
            if ($('.search-word :not(.no-result)').length || !$('.search-word').length) {
                $('.search-word').remove();
                $('.SDS.Search').find(':header').append(sanitizeHtmlStrings("<span class='search-word'></span>"));
                $('.PDS.Search').find(':header').append(sanitizeHtmlStrings("<span class='search-word'></span>"));
                $('.Global.Search').find(':header').append(sanitizeHtmlStrings("<span class='search-word'></span>"));
                $('.TR.Search').find(':header').append(sanitizeHtmlStrings("<span class='search-word'></span>"));
                $('.ILS.Search').find(':header').append(sanitizeHtmlStrings("<span class='search-word'></span>"));
                $('.Products.Search').find(':header').append(sanitizeHtmlStrings("<span class='search-word'></span>"));
            }
            if ($('.search-word').length) {
                if (searchWord.indexOf("&127338") > -1) {
                    searchWord = searchWord.split("&127338").join("&#127338;");
                }
                $('.search-word')[0].innerHTML = sanitizeHtmlStrings(searchWord);
            }
        }

        if (!$('.coveo-new-ui').length) {
            $('.showMoreResults').css('display', 'none');
        }
        $('.CoveoSearchInterface.global .col-lg-9 .paragraph.Global.Search').addClass('no-result');
        $('.CoveoSearchInterface .col-lg-9 .paragraph.TR.Search').addClass('no-result');
    }

    function bindPageLoadEvents() {
        // for procurement search -- mergerd from chemicals
        var coveoroot = Coveo.$$(document).find('.coveo-searchinterface .CoveoSearchInterface');
        Coveo.$$(coveoroot).on('buildingQuery', function (e, args) {
            var searchkey = Coveo.$(".coveo-searchinterface .procurement-search .CoveoSearchbox .magic-box-input input").val();

            if (searchkey !== undefined && searchkey != "") {
                var queryBuilder = args.queryBuilder;
                var aqquery = searchkey.trim();
                if (searchkey.includes(',')) {
                    var trimmedaquery = [];
                    aqquery.split(',').forEach(function (x) { trimmedaquery.push(x.trim()); });
                    aqquery = trimmedaquery.join(',');
                    queryBuilder.expression.remove(searchkey);
                    queryBuilder.expression.add(trimmedaquery.join(' OR '));
                }
                queryBuilder.advancedExpression.addFieldExpression('@z95xname', '==', aqquery.split(','));
            }
        });
        Coveo.$$(coveoroot).on('querySuccess', function (e, args) {
            var qval = Coveo.$(".coveo-searchinterface .procurement-search .CoveoSearchbox .magic-box-input input").val();
            if (qval !== undefined && qval.includes(' OR ')) {
                Coveo.$(".coveo-searchinterface .procurement-search .CoveoSearchbox .magic-box-input input").val(qval.replaceAll(' OR ', ' , '));
            }
            //Added for Micro site Pop up
            if ($('div.microsite-search').length) {
                Anchortags();
            }
        });
        //
        $('.CoveoSearchInterface .coveo-searchbox .CoveoSearchbox .CoveoSearchButton').on('click', function () {
            UpdateSearchHeaderLabel();
            if ($('.component.container.TR.Search .link a').length) {
                var searchUrl = $('.component.container.TR.Search .link a').eq(1).attr('href');
                if (searchUrl !== undefined) {
                    var searchWord = "'" + $('.CoveoSearchInterface .coveo-searchbox .CoveoSearchbox input').val() + "'";
                    var generalUrl = searchUrl.split('?')[0];
                    searchUrl = generalUrl + '?search=' + searchWord;
                    $('.component.container.TR.Search .link a').eq(1).attr("href", searchUrl);
                }
            }
        });
        // focus keypress and key for MC symbol in auto suggest
        $(".coveo-searchinterface .CoveoSearchbox .magic-box-input input").on("focus keyup keypress ", function () {
            setTimeout(function () {
                var a = $(".magic-box-suggestion .coveo-highlight");
                $(a).contents().unwrap();
                if ($(".magic-box-hasSuggestion").length) {
                    for (var i = 0; i < $(".magic-box-hasSuggestion .coveo-top-field-suggestion-row").length; i++) {
                        if ($(".magic-box-hasSuggestion .coveo-top-field-suggestion-row")[i].innerHTML.indexOf("&amp;#127338") > -1)
                            $(".magic-box-hasSuggestion .coveo-top-field-suggestion-row")[i].innerHTML = sanitizeHtmlStrings($(".magic-box-hasSuggestion .coveo-top-field-suggestion-row")[i].innerHTML.split("&amp;#127338").join("&#127338;"));
                    }
                }
            }, 2000);
        });

        if (typeof Coveo === 'undefined' || !$('.coveo-searchinterface .CoveoSearchInterface').length) return;
        var root = Coveo.$$(document).find('.coveo-searchinterface .CoveoSearchInterface');
        Coveo.$$(root).on("deferredQuerySuccess", function (e, args) {
            removeCoveoMinHeight();
            totalResults = args.results.totalCount;
            if (args.query.q) {
                var searchedQueryText = args.query.q.split("*").join("");
                UpdateSearchHeaderLabel("'" + searchedQueryText + "'");
            } else {
                UpdateSearchHeaderLabel();
            }
            if ($('.CoveoSearchInterface .col-lg-9 .coveo-list-layout:visible').length) {
                $('.CoveoSearchInterface .col-lg-3').show();
            }
            if (args.results.totalCount <= coveoResultsPerCall && $(".coveo-resultslist:visible").length) {
                if (!$('.coveo-new-ui').length) {
                    $('.showMoreResults').css('display', 'none');
                }
            }
            else {
                if (!$('.coveo-new-ui').length) {
                    $('.showMoreResults').css('display', 'block');
                }
            }
            addingQuotes();
            manupulateDom();

            dynamicCoveoTitle();
            removingWildcard();
            $('.coveo-spinner').css('display', 'none');
        });

        // Click handler for filter facets
        $("body").on("click", ".refine-filter", function () {
            $(this).siblings().toggleClass("d-none");
            if ($(this).find(".fa-caret-up").length) {
                $(this).find(".fa-caret-up").removeClass("fa-caret-up").addClass("fa-caret-down");
            }
            else {
                $(this).find(".fa-caret-down").removeClass("fa-caret-down").addClass("fa-caret-up");
            }
        });
    }
    function dynamicCoveoTitle() {
        if ($(".product-series-coveo-title").length) {
            var dynamicHeaderText = $(".product-series-coveo-title .field-title").text();
            var modifiedText = "";
            if ($(".pds-heading-text").length) {
                modifiedText = dynamicHeaderText.split("{0}").join($(".pds-heading-text").text());
            }
            if (totalResults !== undefined) {
                modifiedText = modifiedText.split("{1}").join(totalResults);
            }
            if (modifiedText != "") {
                $(".product-series-coveo-title .field-title").text(modifiedText);
            }
        }
        if ($(".CoveoSearchInterface .component.b06-heading:not('.Search') .field-title").length && $('.coveo-highlight').length > 2) {
            var totalCount = $(".CoveoSearchInterface .component.b06-heading .field-title").text();
            if (totalResults !== undefined) {
                var actualTextToDisplay = totalCount.split("{0}").join(totalResults);
                $(".CoveoSearchInterface .component.b06-heading .field-title").text(actualTextToDisplay);
            }
        }
    }
    //Pass additional parameter *
    function isCharecter(input) {
        var expr = new RegExp("[0-9a-zA-Z]");
        return expr.test(input);
    }

    //Check for the special charecter
    function isSpecialCharecter(input) {
        if (/^[a-zA-Z0-9]*$/.test(input) == false) {
            return false;
        }
        else {
            return true;
        }
    }

    function addingQuotes() {
        $("ul.industrial").hide();
        //-- mergerd from chemicals
        if (!$(".CoveoSearchInterface.procurement-search"))
            $(".component.b01-paragraph.paragraph.noresults").hide();
        if (!$('.coveo-query-summary-no-results-string').length) {
            return;
        }
        var hiddenValueText = "";
        if ($(".query-summary-dict-Value").length) {
            hiddenValueText = $(".query-summary-dict-Value").val();
        }
        var noResultText;
        if (hiddenValueText !== "") {
            noResultText = hiddenValueText;
            $('.coveo-query-summary-no-results-string').empty().text(noResultText);
        }
        else {
            var searchKeyword = Coveo.$(".body-content .CoveoSearchbox input").val();
            if (searchKeyword && searchKeyword.indexOf("&127338") > -1) {
                searchKeyword = "'" + searchKeyword.split("&127338").join("&#127338;") + "'";
            }
            if ($('.coveo-query-summary-no-results-string >.coveo-highlight').length)
                $('.coveo-query-summary-no-results-string >.coveo-highlight')[0].innerHTML = sanitizeHtmlStrings(searchKeyword);
        }
        if ($('.coveo-query-summary-no-results-string:visible').length && $("ul.industrial").length) {
            $("ul.industrial").show();
            $('.coveo-query-summary-no-results-string:visible').hide();
        }
        else {
            $("ul.industrial").hide();
            $('.coveo-query-summary-no-results-string').show();
        }
        //-- mergerd from chemicals
        if (!$(".CoveoSearchInterface.procurement-search")) {
            if ($('.coveo-query-summary-no-results-string:visible').length && $("ul.industrial").length) {
                $("ul.industrial").show();
                $('.coveo-query-summary-no-results-string:visible').hide();
                $(".component.b01-paragraph.paragraph.noresults").show();
            } else {
                $("ul.industrial").hide();
                $('.coveo-query-summary-no-results-string').show();
                $(".component.b01-paragraph.paragraph.noresults").hide();
            }
        }
    }

    function removingWildcard() {
        var wildcard;
        var noWildcard;
        if (totalResults === 1 && $('.CoveoQuerySummary .coveo-highlight:eq(2)')) {
            wildcard = $('.CoveoQuerySummary .coveo-highlight:eq(2)').text();
            noWildcard = wildcard.trim();
            noWildcard = noWildcard.split("*").join("");
            if (noWildcard.indexOf("&127338") > -1) {
                noWildcard = noWildcard.split("&127338").join("&#127338;");
            }
            if ($('.CoveoQuerySummary .coveo-highlight:eq(2)').length) {
                $('.CoveoQuerySummary .coveo-highlight:eq(2)')[0].innerHTML = sanitizeHtmlStrings(noWildcard);
            }
        }
        else {
            if (!$('.CoveoQuerySummary .coveo-highlight:eq(3)').length) return;
            wildcard = $('.CoveoQuerySummary .coveo-highlight:eq(3)').text();
            noWildcard = wildcard.trim();
            noWildcard = noWildcard.split("*").join("");
            if (noWildcard.indexOf("&127338") > -1) {
                noWildcard = noWildcard.split("&127338").join("&#127338;");
            }
            if ($('.CoveoQuerySummary .coveo-highlight:eq(3)').length) {
                $('.CoveoQuerySummary .coveo-highlight:eq(3)')[0].innerHTML = sanitizeHtmlStrings(noWildcard);
            }
        }
    }
    function handleShowMoreShowLessLink() {
        var selectedFacets = $(".CoveoFacet .coveo-facet-values");
        for (var i = 0; i < selectedFacets.length; i++) {
            if ($(selectedFacets[i]).find(".coveo-facet-selectable").length && $(selectedFacets[i]).find(".coveo-selected").length === $(selectedFacets[i]).find(".coveo-facet-selectable").length) {
                $(selectedFacets[i]).parents(".CoveoFacet").find(".coveo-facet-footer").hide();
            }
            else {
                $(selectedFacets[i]).parents(".CoveoFacet").find(".coveo-facet-footer").show();
            }
        }
    }

    function manupulateDom() {
        $(".product-list-btn-container .btn-near-you").hide();
        $(".CoveoSearchInterface.ProductGrouping .widget-btn").addClass("d-none");
        $(".product-list-btn-container .btn-compare").hide();
        $(".coveo-facet-header-settings-section > div").attr('tabindex', '-1');

        coveoEventSearch();
        setTimeout(function () {
            setSearchButtonFocus();
            addCheckboxRole();

            if ($("header .magic-box-notEmpty").length) {
                $("header .magic-box-notEmpty").find("input").val("");
            }
            if ($("footer .magic-box-notEmpty").length) {
                $("footer .magic-box-notEmpty").find("input").val("");
            }

            if (!$(".coveo-query-summary-no-results-string").length && $(".CoveoQuerySummary[data-noresults-found] span .coveo-query-summary-cancel-last").length) {
                $(".CoveoQuerySummary[data-noresults-found] span .coveo-query-summary-cancel-last").parent().prepend('<div class="coveo-query-summary-no-results-string">' + $(".CoveoQuerySummary[data-noresults-found]").data('noresultsFound').split("{0}").join($(".screen-title-title").text()) + '</div>');
            }
            if ($('.component.link.SearchHeading a').length) {
                var searchUrl = $('.component.link.SearchHeading a').eq(1).attr('href');
                if (searchUrl !== undefined) {
                    var searchWord = "'" + $('.CoveoSearchInterface.global .CoveoSearchbox input').val() + "'";
                    var generalUrl = searchUrl.split('?')[0];
                    searchUrl = generalUrl + '?search=' + searchWord;
                    $('.component.link.SearchHeading a').eq(1).attr("href", searchUrl);
                }
            }
            if ($(".CoveoSearchInterface.refinefacets").length) {
                if ($(".refine-filter").length) {
                    $(".refine-filter").empty().remove();
                }
                $(".CoveoSearchInterface.refinefacets .col-lg-3").prepend("<div class='refine-filter d-md-none'>" + $(".CoveoSearchInterface.refinefacets").attr("data-refinefacet") + "<span class='fas fa-caret-up pull-right'></span></div>");
            }
            if ($(".resource-category").length) {
                var resourceCategories = $(".resource-category");
                for (var i = 0; i < resourceCategories.length; i++) {
                    var textToReplace = $(resourceCategories[i]).text().split(";").join(" , ");
                    $(resourceCategories[i]).text(textToReplace);
                }
                $(".resource-category").show();
            }
            if ($(".product-compare-flyout:visible").length && $(".product-placeholder .non-active").length === 0 && $(".product-list-btn-container .btn-compare").length) {
                $(".product-list-btn-container .btn-compare").addClass("disabled");
            }
            else if ($(".product-list-btn-container .btn-compare").length) {
                $(".product-list-btn-container .btn-compare").removeClass("disabled");
            }
            if ($('.coveo-searchinterface .CoveoSearchInterface.ProductGrouping').length) {
                coveoResultsPerCall = 12;
                if (window.outerWidth < 768) {
                    $(".product-list-btn-container a").addClass("glyph-link");
                }
                $(".product-list-btn-container .btn-compare").empty().text($("#CompareButtonText").val()).append(sanitizeHtmlStrings("<i class='fa fa-angle-right d-none-md'></i>"));
                $(".product-list-btn-container .btn-compare").show();

                if (hasProductSellerConsent()) {
                    $(".product-list-btn-container .btn-near-you").hide();
                    $(".CoveoSearchInterface.ProductGrouping .widget-btn").removeClass("d-none");
                }
                else {
                    $(".product-list-btn-container .btn-near-you").text($("#FindItNearYouText").val()).append(sanitizeHtmlStrings("<i class='fa fa-angle-right d-none-md'></i>"));
                    $(".product-list-btn-container .btn-near-you").attr("href", $("#FindItNearYouUrl").val());
                    if ($("#FindItNearYouText").val().length > 0) {
                        $(".product-list-btn-container .btn-near-you").show();
                    }
                    $(".CoveoSearchInterface.ProductGrouping .widget-btn").addClass("d-none");
                }
                if (!hasCoveoCookieConsent()) {
                    $(".reviewContainer").hide();
                }
                else {
                    $(".reviewContainer").show();
                }
                addingQuotes();
            }
            localStorage.removeItem("__coveo.analytics.history");
            if ($('.coveo-sort-container')) {
                $('.coveo-sort-container span.CoveoSort.coveo-accessible-button').removeAttr('tabindex');
            }
            if ($('.coveo-new-ui').length) {
                if (!$('.CoveoResult').length) {
                    $('.wrap-div-float').css('display', 'none');
                    $('.custom-date-sort').css('display', 'none');
                    $('.seeallList').css('display', 'none');
                    $('.seeLessList').css('display', 'none');
                    $('.pipe-divider').css('display', 'none');
                } else {
                    $('.wrap-div-float').css('display', 'flex');
                    $('.custom-date-sort').css('display', 'block');
                    if (!seeAllClicked) {
                        $('.seeallList').css('display', 'inline');
                        $('.pipe-divider').css('display', 'inline');
                    } else {
                        $('.seeallList').css('display', 'none');
                    }
                    if ($('.CoveoResult').length < 10) {
                        if (seeAllClicked) {
                            $('.seeallList').css('display', 'none');
                        } else {
                            $('.seeallList').css('display', 'inline');
                        }
                        if ($('.seeallList').length > 0 || $('.seeallList').length > 0) {
                            $('.pipe-divider').css('display', 'inline');
                        } else {
                            $('.pipe-divider').css('display', 'none');
                        }
                    }
                }
            }
            setTimeout(function () {
                containerElementEmptyIssue();
            }, 2000);
        }, 2000);
    }

    function onDomReady() {

        if ($('.coveo-new-ui').length) {
            $(".date-selected-sorting").click(function () {
                $('.coveo-sort-section').toggle();
            });
            $(".coveo-sort-section .CoveoSort").click(function () {
                var selectedDate = $(this).html();
                $('.date-selected-sorting span').html(selectedDate);
                seeAllClicked = false;
                seeLessClicked = false;
                $('.seeallList').css('display', 'inline');
                $('.seeLessList').css('display', 'none');
                if (seeLessClicked) {
                    $('.seeLessList').css('display', 'none');
                }
                $('.coveo-dateSort').hide();
            });
        }

        setSearchButtonFocus();

        if ($('.ils').length) {
            if ((!$('.ils .coveo-searchbox').length) || ($(".ils .CoveoSearchbox .magic-box-input").text().trim() != '')) {
                $('.CoveoSearchInterface.ils .coveo-placeholder-result').css('display', 'block');
                $('.CoveoSearchInterface.ils .col-lg-3').css('display', 'block');
                $('.CoveoSearchInterface.ils .col-lg-9 p').css('display', 'block');
                $('.CoveoSearchInterface.ils .col-lg-9').css('display', 'block');
                $('.showMoreResults').css('display', 'block');
            }
        }

        if (($('.trsearch').length) || ($('.global').length) || ($('.events-search').length)) {
            if (!$('.coveo-new-ui').length) {
                $('.showMoreResults').css('display', 'block');
            }
        }
        if ($('.CoveoSearchInterface.emebs').length) {
            if (!$('.coveo-new-ui').length) {
                $('.showMoreResults').css('display', 'none');
            }
        }
        if ($('.events-search').length) {
            $('.CoveoSearchInterface.events-search .col-lg-3').css('display', 'block');
        }
        if (typeof Coveo === 'undefined' || !$('.coveo-searchinterface .CoveoSearchInterface').length) {
            if ($('.coveo-globalsearchbox').length) {
                setTimeout(function () {
                    addSearchButtonLabel();
                    addGoToGlobalSearch();
                    var cookiename = 'Exxon-last-searches';
                    ToggelLastSearch(cookiename);
                }, 1000);
            }

            return;
        }

        var root = Coveo.$$(document).find('.coveo-searchinterface .CoveoSearchInterface');
        // Initialise SDS/PDS-specific Coveo and DOM event handlers (defined in _sds-pds-search.js).
        if (window.CoveoSdsPds) window.CoveoSdsPds.initSdsPdsEvents();

        Coveo.$$(root).on("afterInitialization", function () {
            localStorage.removeItem("__coveo.analytics.history");

            setTimeout(function () {
                onWindowLoad();
                dynamicCoveoTitle();
                addingQuotes();
                removingWildcard();
                manupulateDom();
            }, 1000);
            if ($('.product-search').length) {
                if (!$('.coveo-new-ui').length) {
                    $('.showMoreResults').css('display', 'block');
                }
            }
        });

        Coveo.$$(root).on("newResultsDisplayed", function () {
            var $mainTag = $('main.coveo-height-wrapper');
            if ($mainTag.length) {
                $mainTag.removeClass('coveo-height-wrapper');
            }
        });

        $('.seeallList').click(function (e, args) {
            seeAllClicked = true;
            seeAllClickedFirst = false;
            var size = $('.coveo-highlight')[2].innerHTML;
            $(".coveo-searchbox .CoveoSearchButton").trigger("click", ['seeall']);
            //   Coveo.$('.CoveoResultList').coveo('displayMoreResults', seeAllResCount);
            if ($('.coveo-highlight').length) {
                /*  var coveoResultsLoaded = 0;
                  coveoResultsLoaded = $('.coveo-highlight')[1] ? sanitizeHtmlStrings($('.coveo-highlight')[1].innerHTML) : 0;
                  var coveoResultsAvailable = 0;
                  var maxCount = $(".coveo-highlight").get().map(function (el) {
                      var valueToreturn = parseInt(el.textContent.replace(/[^a-z0-9]/gi, '').split(" ").join("").split("&nbsp;").join(""));
                      return isNaN(valueToreturn) ? 0 : valueToreturn;
                  });

                  var finalResultCount = Math.max.apply(null, maxCount);
                  var maxIndex = maxCount.indexOf(finalResultCount);

                  maxCount[maxIndex] = -1;
                  var intitalCount = Math.max.apply(null, maxCount);
                  var indexOfResultsLoaded = maxCount.indexOf(intitalCount);
                       $('.coveo-highlight')[0].innerHTML = sanitizeHtmlStrings(1);
                    //   $('.coveo-highlight')[indexOfResultsLoaded].innerHTML = sanitizeHtmlStrings(finalResultCount);*/
                if (!$('.coveo-new-ui').length) {
                    $('.showMoreResults').css('display', 'none');
                }
            }
            else if ($(".coveo-searchinterface .CoveoSearchInterface .coveo-list-layout:visible").length) {
                if ($(".coveo-searchinterface .CoveoSearchInterface .coveo-list-layout:visible").length + size >= totalResults) {
                    if (!$('.coveo-new-ui').length) {
                        $('.showMoreResults').css('display', 'none');
                    }
                }
                else {
                    if (!$('.coveo-new-ui').length) {
                        $('.showMoreResults').css('display', 'block');
                    }
                }
            }
            else if ($(".coveo-searchinterface .CoveoSearchInterface .coveo-card-layout:visible").length) {
                if ($(".coveo-searchinterface .CoveoSearchInterface .coveo-card-layout:visible").length + size >= totalResults) {
                    $('.showMoreResults').css('display', 'none');
                }
                else {
                    $('.showMoreResults').css('display', 'block');
                }
            }

            $('.pipe-divider').css('display', 'inline');
            $('.seeallList').css('display', 'none');
            $('.seeLessList').css('display', 'inline');
            if ($('.coveo-pager-next').length) {
                $('.coveo-pager-next').css('display', 'none');
            }
            if ($('.coveo-pager-previous').length) {
                $('.coveo-pager-previous').css('display', 'none');
            }
            setTimeout(function () {
                if ($('.CoveoResult').length) {
                    $('.coveo-highlight')[1].innerHTML = sanitizeHtmlStrings($('.CoveoResult').length);
                }
            }, 3000);
        });

        $('.seeLessList').click(function (e, args) {
            seeLessClicked = true;
            seeAllClickedFirst = (seeAllClicked && seeLessClicked) ? true : false;
            $(".coveo-searchbox .CoveoSearchButton").trigger("click", ["seeless"]);
            $(".CoveoResult").first().focus();
            $('.seeLessList').css('display', 'none');
            $('.seeallList').css('display', 'inline');
        });

        $('.showMoreResults').click(function (e, args) {
            var size = coveoResultsPerCall;
            Coveo.$('.CoveoResultList').coveo('displayMoreResults', size);
            if ($('.coveo-highlight').length) {
                var coveoResultsLoaded = 0;
                coveoResultsLoaded = $('.coveo-highlight')[1] ? sanitizeHtmlStrings($('.coveo-highlight')[1].innerHTML) : 0;
                var coveoResultsAvailable = 0;
                //var maxCount = $(".coveo-highlight").get().map(function (el) {
                //    var valueToreturn = parseInt(el.textContent.replace(/[^a-z0-9]/gi, '').split(" ").join("").split("&nbsp;").join(""));
                //    return isNaN(valueToreturn) ? 0 : valueToreturn;
                //});
                var maxCount = $(".coveo-highlight").get().map(function (el) {
                    if (!$(el).hasClass('coveo-highlight-query')) {
                        var valueToreturn = parseInt(el.textContent.replace(/[^a-z0-9]/gi, '').split(" ").join("").split("&nbsp;").join(""));
                        return isNaN(valueToreturn) ? 0 : valueToreturn;
                    }
                    else {
                        return 0;
                    }
                });
                //-- mergerd from chemicals
                if ($('.coveo-highlight').length >= 4) {
                    maxCount.pop();
                }
                var finalResultCount = Math.max.apply(null, maxCount);
                var maxIndex = maxCount.indexOf(finalResultCount);
                maxCount[maxIndex] = -1;
                var intitalCount = Math.max.apply(null, maxCount);
                var indexOfResultsLoaded = maxCount.indexOf(intitalCount);
                if (intitalCount + size >= finalResultCount) {
                    $('.coveo-highlight')[indexOfResultsLoaded].innerHTML = sanitizeHtmlStrings(finalResultCount);
                    if (!$('.coveo-new-ui').length || $('.enhance-search-coveo').length) {
                        $('.showMoreResults').css('display', 'none');
                    }
                }
                else {
                    var getCalCount = intitalCount + size;
                    $('.coveo-highlight')[indexOfResultsLoaded].innerHTML = sanitizeHtmlStrings(getCalCount);
                }
            }
            else if ($(".coveo-searchinterface .CoveoSearchInterface .coveo-list-layout:visible").length) {
                if ($(".coveo-searchinterface .CoveoSearchInterface .coveo-list-layout:visible").length + size >= totalResults) {
                    if (!$('.coveo-new-ui').length) {
                        $('.showMoreResults').css('display', 'none');
                    }
                }
                else {
                    if (!$('.coveo-new-ui').length) {
                        $('.showMoreResults').css('display', 'block');
                    }
                }
            }
            else if ($(".coveo-searchinterface .CoveoSearchInterface .coveo-card-layout:visible").length) {
                if ($(".coveo-searchinterface .CoveoSearchInterface .coveo-card-layout:visible").length + size >= totalResults) {
                    if (!$('.coveo-new-ui').length) {
                        $('.showMoreResults').css('display', 'none');
                    }
                }
                else {
                    if (!$('.coveo-new-ui').length) {
                        $('.showMoreResults').css('display', 'block');
                    }
                }
            }
            //--mergerd from chemicals
            //Added for Micro site Pop up
            if ($('div.microsite-search').length) {
                setTimeout(function () {
                    Anchortags();
                }, 1000);
            }
        });

        Coveo.$$(root).on("afterComponentsInitialization", function () {
            localStorage.removeItem("__coveo.analytics.history");
            var model = Coveo.$('.coveo-searchinterface .CoveoSearchInterface').coveo(Coveo.QueryStateModel);
            model.registerNewAttribute('seeMoreResults', coveoResultsPerCall);
        });
        Coveo.$$(root).on("doneBuildingQuery", function (e, args) {
            var coveoQuerybuilderAvailable = args && args.queryBuilder;
            //for UL table with  dps search -- mergerd from chemicals
            var queryKey = Coveo.$(".coveo-searchinterface .signpoly_searchTable .CoveoSearchbox .magic-box-input input").val();
            if (queryKey !== undefined && queryKey != "") {
                var searchTerm = queryKey;
                var modifiedSearchTerm = searchTerm.lastIndexOf(' - ');
                if (modifiedSearchTerm !== -1) {
                    searchTerm = searchTerm.substring(0, modifiedSearchTerm).trimEnd();
                }
                args.queryBuilder.expression.parts = [searchTerm];
            }
            // for chemicals search -- mergerd from chemicals
            var searchkey = Coveo.$(".coveo-searchinterface .chemical-search .CoveoSearchbox .magic-box-input input").val();
            if (searchkey !== undefined && searchkey != "") {
                var queryBuilder = args.queryBuilder;
                var qre = createQre("@doctitle==\"" + searchkey + "\" @chemicalskldocumenttype==Webpage", 2800);
                queryBuilder.advancedExpression.add(qre);
                var qre1 = createQre("@doctitle~=\"" + searchkey + "*\" @chemicalskldocumenttype==Webpage", 1800);
                queryBuilder.advancedExpression.add(qre1);
                var qre2 = createQre("@doctitle==\"" + searchkey + "\"", 1000);
                queryBuilder.advancedExpression.add(qre2);
                var qre8 = createQre("@doctitle~=\"" + searchkey + "*\" @chemicalskldocumenttype==\"Product safety summaries\"", -1600);
                queryBuilder.advancedExpression.add(qre8);
                var qre3 = createQre("@doctitle~=\"" + searchkey + "*\"", 800);
                queryBuilder.advancedExpression.add(qre3);
            }
            //sort criteria set for Webinars, Events, Library assets, Newsroom asset
            var coveosearchinterfaceele = Coveo.$(".coveo-searchinterface");
            if (coveosearchinterfaceele !== undefined && coveosearchinterfaceele != null && coveosearchinterfaceele.length) {
                var magicboxinputclassnamecheck = coveosearchinterfaceele[0].querySelector('.chemical-search');
                if (magicboxinputclassnamecheck == null) {
                    magicboxinputclassnamecheck = coveosearchinterfaceele[0].querySelector('.events-search');
                    var magicboxsearchkeyclassname = ".coveo-searchinterface .events-search .CoveoSearchbox .magic-box-input input";
                    var sortcriteria = '@eventz32xstartdate descending';
                    if (magicboxinputclassnamecheck == null) {
                        magicboxinputclassnamecheck = coveosearchinterfaceele[0].querySelector('.library-search');
                        magicboxsearchkeyclassname = ".coveo-searchinterface .library-search .CoveoSearchbox .magic-box-input input";
                        sortcriteria = '@updated descending';
                    }
                    if (magicboxinputclassnamecheck == null) {
                        magicboxinputclassnamecheck = coveosearchinterfaceele[0].querySelector('.pressrelease-search');
                        magicboxsearchkeyclassname = ".coveo-searchinterface .pressrelease-search .CoveoSearchbox .magic-box-input input";
                        sortcriteria = '@created descending';
                    }
                    if (magicboxinputclassnamecheck != null) {
                        var imputsearchkey = Coveo.$(magicboxsearchkeyclassname).val();
                        if (imputsearchkey !== undefined && imputsearchkey != "") {
                            var coveoqueryBuilder = args.queryBuilder;
                            var qr1 = createQre("@doctitle==\"" + imputsearchkey + "\"", 2800);
                            coveoqueryBuilder.advancedExpression.add(qr1);
                            var qr2 = createQre("@doctitle~=\"" + imputsearchkey + "*", 1800);
                            coveoqueryBuilder.advancedExpression.add(qr2);
                        } else if (isChemicalSite) {
                            args.queryBuilder.sortCriteria = sortcriteria;
                            Coveo.state(root, 'sort', sortcriteria);
                        }
                    }
                }
            }
            // for procurement search
            if (Coveo.$(".coveo-searchinterface .procurement-search").length && Coveo.$(".coveo-searchinterface .procurement-search .CoveoSearchbox .magic-box-input input").val().trim() === "") {
                $(".component.b01-paragraph.paragraph.procurement-no-document").show();
                if ($(".component.b01-paragraph.paragraph.procurement-no-document").length)
                    $(".component.b01-paragraph.paragraph.procurement-no-document").removeClass('d-none');
                $(".procurement-search .coveo-resultslist").hide();
                $(".procurement-search .procurement-default-search").hide();
                $(".procurement-search .b06-heading").hide();
                $(".noresults").hide();
                args.cancel = true;
                return;
            } else {
                $(".component.b01-paragraph.paragraph.procurement-no-document").hide();
                $(".procurement-search .coveo-resultslist").show();
                $(".procurement-search .b06-heading").show();
                if ($(".procurement-search .b06-heading").length)
                    $(".procurement-search .b06-heading").removeClass('d-none');
                if ($(".procurement-search .procurement-default-search").length)
                    $(".procurement-search .procurement-default-search").removeClass('d-none');
            }
            if (coveoQuerybuilderAvailable && $(".coveo-omnibox-selected").length && args.queryBuilder.expression && args.queryBuilder.expression.parts && args.queryBuilder.expression.parts.length === 0) {
                var _expressionBuilder = new Coveo.ExpressionBuilder();
                _expressionBuilder.add(decodeURIComponent(Coveo.$(".coveo-omnibox-selected").text()));
                args.queryBuilder.expression = _expressionBuilder;
            }
            if (args.queryBuilder.advancedExpression.parts.length > 0) {
                var inputBoxValues = Coveo.$(".coveo-searchinterface .CoveoSearchbox .magic-box-input input").val();
                if (inputBoxValues != '') {
                    for (i = 0; i < args.queryBuilder.advancedExpression.parts.length; i++) {
                        if (args.queryBuilder.advancedExpression.parts[i].includes('{searchkey}')) {
                            args.queryBuilder.advancedExpression.parts[i] = args.queryBuilder.advancedExpression.parts[i].replace('{searchkey}', inputBoxValues);
                        }
                    }
                }
            }
            if (seeAllClicked && !seeAllClickedFirst)
                args.queryBuilder.numberOfResults = seeAllResCount;
            else
                args.queryBuilder.numberOfResults = coveoResultsPerCall;

            if (Coveo && Coveo.$(".coveo-searchinterface .CoveoSearchbox .magic-box-input input").length && Coveo.$(".coveo-searchinterface .CoveoSearchbox .magic-box-input input").val()) {
                var inputBoxValue = Coveo.$(".coveo-searchinterface .CoveoSearchbox .magic-box-input input").val();

                if (coveoQuerybuilderAvailable && inputBoxValue.replace(/[-_;()]/gi, ' ').trim().replace(/[!%'"#<>\{\}\\\/]/gi, '').length && args.queryBuilder.expression && args.queryBuilder.expression.parts && args.queryBuilder.expression.parts.length === 0) {
                    var expressionBuilder1 = new Coveo.ExpressionBuilder();
                    expressionBuilder1.add(decodeURIComponent(Coveo.$(".coveo-searchinterface .CoveoSearchbox .magic-box-input input").val()));
                    args.queryBuilder.expression = expressionBuilder1;
                }
            }

            if ((args && args.queryBuilder) && (args.queryBuilder.expression.build() != undefined)) {
                handleShowMoreShowLessLink();
                var expression = decodeURIComponent(args.queryBuilder.expression.build().replace(/[-_;()]/gi, ' ').trim().replace(/[!%'"#<>\{\}\\\/]/gi, ''));
                if (expression.lastIndexOf('*') === expression.length - 1) {
                    expression = expression.substr(0, expression.length - 1);
                }
                if (expression != "") {
                    var spiltArray = expression.split(" ");
                    if (Coveo.$(".coveo-searchinterface .CoveoSearchbox .magic-box-input input").length) {
                        Coveo.$(".coveo-searchinterface .CoveoSearchbox .magic-box-input input").val(expression);
                        UpdateSearchHeaderLabel();
                    }
                    //var tempArray = "";
                    //for (i = 0; i < spiltArray.length; i++) {
                    //    var searchWord = spiltArray[i];
                    //    if (searchWord.length > 2 && isSpecialCharecter(searchWord) && isCharecter(searchWord.charAt(searchWord.length - 1))) {
                    //        spiltArray[i] = spiltArray[i] + "*";
                    //    }
                    //}
                    //expression = spiltArray.join(" ");

                    // Replace the ExpressionBuilder with a new one
                }
                else {
                    expression = '';
                }
                var expressionBuilder = new Coveo.ExpressionBuilder();
                expressionBuilder.add(expression);
                args.queryBuilder.expression = expressionBuilder;
            }
            $(".CoveoSearchbox .magic-box-input input").attr("disabled", true);
            // $(".CoveoSearchButton").focus();
            $('.coveo-spinner').css('display', 'inline-flex');
        });

        //-- mergerd from chemicals
        var createQre = function (expression, modifier) { return "$qre(expression:'(" + expression + ")', modifier:" + modifier + ")"; };
        Coveo.$$(root).on("fetchMoreSuccess", function (e, args) {
            manupulateDom();
            //Added for Micro site Pop up -- mergerd from chemicals
            if ($('div.microsite-search').length) {
                setTimeout(function () {
                    Anchortags();
                }, 1000);
            }
        });
        Coveo.$$(root).on("querySuccess", function (e, args) {
            removeCoveoMinHeight();
            totalResults = args.results.totalCount;

            // --mergerd from chemicals
            setTimeout(function () {
                handleShowMoreShowLessLink();
                //Added for Micro site Pop up
                if ($('div.microsite-search').length) {
                    Anchortags();
                }
            }, 500);

            var searchedQueryText;
            if (args.query.q) {
                searchedQueryText = args.query.q.split("*").join("");
                UpdateSearchHeaderLabel("'" + searchedQueryText + "'");
            }
            else {
                UpdateSearchHeaderLabel();
            }

            dynamicCoveoTitle();
            if (args.results.totalCount === 0 && !$(this).parent().hasClass('coveo-page-editor-editing')) {
                $('.searchresults-hide').show();
                $('.s01-surfaced-item').show();
                $('.search-word').addClass('no-result');
                $('.CoveoSearchInterface .col-lg-3').addClass('no-result').css("display", "none");
                $('.CoveoSearchInterface .col-lg-9 .b01-paragraph.paragraph').css("display", "none");
                $('.showMoreResults').css('display', 'none');
                $('.CoveoSearchInterface.global .col-lg-9 .paragraph.Global.Search').addClass('no-result');
                $('.CoveoSearchInterface .col-lg-9 .paragraph.TR.Search').addClass('no-result');
                if ($('.pds').length) {
                    if ($('.CoveoSearchInterface.pds .col-lg-3').css('display') == 'block') {
                        $('.CoveoSearchInterface.pds .col-lg-3').css('display', 'none');
                    }
                }
                if ($('.events-search').length) {
                    $('.CoveoSearchInterface.events-search .col-lg-3').css('display', 'none');
                    $('.CoveoSearchInterface.events-search table.product-list').css('display', 'none');
                    $('.CoveoSearchInterface.events-search .showMoreResults').css('display', 'none');
                    $('.CoveoSearchInterface.events-search .coveo-querysummary').css('display', 'block');
                }

                // $('.CoveoSearchInterface').find('.coveo-result-list-container').trigger('SearchResultsRendering', [{ "searchResults": args.results.totalCount }]);
                // for procurement search -- mergerd from chemicals
                $(".noresults").show();
                if ($(".noresults").length)
                    $(".noresults").removeClass('d-none');
                $(".procurement-search .procurement-default-search").hide();
            } else {
                $('.CoveoSearchInterface .col-lg-9 .b01-paragraph.paragraph').css("display", "block");
                if ($(".coveo-result-list-container:visible").length && $(".searchresults-hide").length) {
                    $('.searchresults-hide').hide();
                    $('.s01-surfaced-item').hide();
                }
                $('.CoveoSearchInterface .col-lg-3').removeClass('no-result').show();
                $('.search-word').removeClass('no-result');
                // for procurement search -- mergerd from chemicals
                $(".noresults").hide();
                $(".procurement-search .procurement-default-search").show();
                if (args.results.totalCount <= coveoResultsPerCall) {
                    if (!$('.coveo-new-ui').length || $('.enhance-search-coveo').length) {
                        $('.showMoreResults').css('display', 'none');
                    }
                }
                else {
                    if (!$('.coveo-new-ui').length || $('.enhance-search-coveo').length) {
                        $('.showMoreResults').css('display', 'block');
                    }
                }
                $('.CoveoSearchInterface.global .col-lg-9 .paragraph.Global.Search').removeClass('no-result');
                $('.CoveoSearchInterface .col-lg-9 .paragraph.TR.Search').removeClass('no-result');
                if ($('.pds').length) {
                    if ($('.CoveoSearchInterface.pds .col-lg-3').css('display') == 'none' && $('.coveo-query-summary-no-results-string').length > 0) {
                        $('.CoveoSearchInterface.pds .col-lg-3').css('display', 'block');
                    }
                }
                if ($('.product-search').length) {
                    if ($('.CoveoSearchInterface.product-search .col-lg-3').css('display') == 'none' && $('.coveo-query-summary-no-results-string').length > 0) {
                        $('.CoveoSearchInterface.product-search .col-lg-3').css('display', 'block');
                    }
                }
                //merged from chemical
                if ($('.events-search').length) {
                    $('.CoveoSearchInterface.events-search .col-lg-3').css('display', 'block');
                    $('.CoveoSearchInterface.events-search table.product-list').css('display', 'table');
                    if (args.results.totalCount <= coveoResultsPerCall) {
                        if (!$('.coveo-new-ui').length) {
                            $('.CoveoSearchInterface.events-search .showMoreResults').css('display', 'none');
                        }
                    }
                    else {
                        if (!$('.coveo-new-ui').length) {
                            $('.CoveoSearchInterface.events-search .showMoreResults').css('display', 'block');
                        }
                    }
                    //-- mergerd from chemicals
                    $('.CoveoSearchInterface.events-search .coveo-querysummary').css('display', 'block');
                } else {
                    $('.CoveoSearchInterface.events-search .coveo-querysummary').css('display', 'none');
                }
                if ($(".resource-category").length) {
                    $(".resource-category").hide();
                }
                // $('.CoveoSearchInterface').find('.coveo-result-list-container').trigger('SearchResultsRendering', [{ "searchResults": args.results.totalCountFiltered }]);
                manupulateDom();
            }
            setTimeout(function () {
                if (!$('.coveo-query-summary-no-results-string >.coveo-highlight').length)
                    addingQuotes();
            }, 500);
            var cookiename = 'Exxon-last-searches';
            var queryBuilder = args.queryBuilder.expression.build();
            if (!args.queryBuilder.expression.isEmpty()) {
                GenrateCookie(cookiename, searchedQueryText);
                ToggelSearchSuggestion(queryBuilder);
            }
            removingWildcard();
            ToggelLastSearch(cookiename);
            $(".CoveoSearchbox .magic-box-input input").attr("disabled", false);
            $('.coveo-spinner').css('display', 'none');
        });

        if ($('.component.coveo-searchbox').length > 0) {
            var observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    if (mutation.addedNodes && mutation.addedNodes.length > 0) {
                        // element added to DOM
                        var hasBeenAdded = Array.from(mutation.addedNodes).some(function (node) { return node.classList && node.classList.contains('magic-box-clear-svg'); });
                        if (hasBeenAdded) {
                            $('.magic-box-clear-svg title').remove();
                        }
                    }
                });
            });

            var config = { attributes: true, childList: true, characterData: true, subtree: true };
            observer.observe($('.component.coveo-searchbox')[0], config);
        }
    }
    function navigateToSearchResults(inputText) {
        if ($("[name='Custom-Global-Search']").length) {
            var currentUrl = document.location.href;
            var facets = "";
            if (currentUrl.split("#").length > 1) {
                facets = "&" + document.location.href.split("#")[1];
            }
            var urlToRedirect = $("[name='Custom-Global-Search']").val() + "#q=" + inputText.replace(/[-_;()]/gi, ' ').replace(/[!%'"#<>\{\}\\\/]/gi, '') + facets;
            document.location.href = window.encodeURI(sanitizeHtmlStrings(decodeURI(urlToRedirect)));
        }
    }
    function populateShowFacetTexts(value) {
        $leftFacets = $('.component.coveo-facet:not(".top-facet .component.coveo-facet")');
        if (!$leftFacets.length) return;
        var showMoreText, showLessText;
        var ariaShowMore, ariaShowLess;
        $leftFacets.each(function (i, facet) {
            showMoreText = $(facet).find('.facet-showMore .FacetText').text().trim();
            showLessText = $(facet).find('.facet-showLess .FacetText').text().trim();
            ariaShowMore = showMoreText + ' ' + $(facet).find('.coveo-facet-header-title-section .coveo-facet-header-title').text().trim();
            ariaShowLess = showLessText + ' ' + $(facet).find('.coveo-facet-header-title-section .coveo-facet-header-title').text().trim();
            if (!$(facet).find('.coveo-facet-less .showLessText').length) {
                $(facet).find('.coveo-facet-less').append(sanitizeHtmlStrings('<span class="showLessText" >' + showLessText + '</span>'));
            }
            if (!$(facet).find('.coveo-facet-more .showMoreText').length) {
                $(facet).find('.coveo-facet-more').append(sanitizeHtmlStrings('<span class="showMoreText" >' + showMoreText + '</span>'));
            }
        });
        if (value == 'load' && (showMoreText != '' || showLessText != '')) {
            facetFlag = true;
        }
    }

    function showResultsPDS() {
        if (!$('.CoveoSearchInterface.pds').length) return;
        if ($('.CoveoSearchInterface.pds .col-lg-9').css('display') == 'none') {
            $('.CoveoSearchInterface.pds .col-lg-9').css('display', 'block');
        }
    }

    function showTenResults() {
        if (typeof Coveo === 'undefined' || !$('.coveo-searchinterface .CoveoSearchInterface').length) return;
        var root = Coveo.$$(document).find('.coveo-searchinterface .CoveoSearchInterface');

        $('a.CoveoSearchButton').on('click', function (event, str) {
            seeAllClicked = false;
            $('.seeLessList').css('display', 'none');
            if (str && (str === 'seeall')) {
                seeAllClicked = true;
            } else {
                seeAllClicked = false;
            }
            if ($('.seeallList').length) {
                $('.seeallList').css('display', 'inline-block');
            }
            if ($('.pipe-divider').length) {
                $('.pipe-divider').css('display', 'inline-block');
            }
            if ($('.coveo-pager-next').length) {
                $('.coveo-pager-next').css('display', 'inline-block');
            }
            if ($('.coveo-pager-previous').length) {
                $('.coveo-pager-previous').css('display', 'inline-block');
            }
            if (typeof Coveo !== 'undefined' && $('.coveo-searchinterface .CoveoSearchInterface').length) {
                var inputText = Coveo.$(".CoveoSearchbox .magic-box-input").text();
                if (inputText.replace(/[-_;()]/gi, ' ').trim().replace(/[!%'"#<>\{\}\\\/]/gi, '') === '') {
                    return;
                }
                navigateToSearchResults(inputText);
            }

            if ($('.CoveoSearchInterface .col-lg-3').css('display') == 'none' && !$('.CoveoSearchInterface .col-lg-3.no-result').length) {
                $('.CoveoSearchInterface .col-lg-3').css('display', 'block');
            }
            if ($('.CoveoSearchInterface .col-lg-9 p').css('display') == 'none') {
                $('.CoveoSearchInterface .col-lg-9 p').css('display', 'block');
            }
            if ($('.CoveoSearchInterface #A05Searchbox_Recentsearch').css('display') == 'none' && hasCoveoCookieConsent()) {
                $('.CoveoSearchInterface #A05Searchbox_Recentsearch').css('display', 'block');
            }

            if ($('.CoveoSearchInterface.ils .col-lg-9').css('display') == 'none') {
                $('.CoveoSearchInterface.ils .col-lg-9').css('display', 'block');
            }

            if (!facetFlag && (!$('.trsearch').length)) {
                populateShowFacetTexts('click');
                facetFlag = true;
            }

            showResultsPDS();
        });
    }

    /******* Coveo last search stars here**********/
    function checkvalueExists(nameValueCol, searchVal, searchUrl) {
        var hasMatch = false;
        for (idx = 0; idx < nameValueCol.length; idx++) {
            if (nameValueCol[idx].SearchText.toLowerCase() == searchVal.toLowerCase()) {
                hasMatch = true;
            }
        }
        return hasMatch;
    }

    function setCookie(cname, cvalue, exdays) {
        if (hasCoveoCookieConsent()) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = sanitizeHTML(cname) + "=" + encodeURIComponent(sanitizeHTML(cvalue)) + ";" + expires + ";path=/";
        }
    }

    function getCookie(cname) {
        if (!hasCoveoCookieConsent()) {
            return;
        }

        var name = cname + "=";
        var tempCookieValue = sanitizeHTML(document.cookie);
        var decodedCookie = decodeURIComponent(tempCookieValue);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return;
    }

    function hasProductSellerConsent() {
        var hasConsent = true;
        if (typeof consentManager != "undefined") {
            hasConsent = consentManager.isCategoryActive("ProductSeller");
        }
        return hasConsent;
    }

    function hasCoveoCookieConsent() {
        var hasConsent = true;
        if (typeof consentManager != "undefined") {
            hasConsent = consentManager.isCategoryActive("CoveoSearch");
        }
        return hasConsent;
    }

    function GenrateCookie(cookiename, searchedQueryText) {
        var CollectData = [];
        var cookieText = searchedQueryText ? searchedQueryText : Coveo.$(".body-content .CoveoSearchbox input").val();
        CollectData.push({ SearchText: encodeURIComponent(cookieText.replace(/[-_;()]/gi, ' ').replace(/[!%'"#<>\{\}\\\/]/gi, '')), SearchUrl: window.location.origin + window.location.pathname });
        if (($(".SDS.Search").length || $(".PDS.Search").length) && CollectData.length) {
            CollectData[0].SearchUrl = window.location.href;
        }
        var jsonString = JSON.stringify(CollectData);

        var getValue = getCookie(cookiename);
        if (getValue != null && getValue != 'undefined') {
            getValue = getValue.replace("\\", "\\\\");
            var nameValueCol = JSON.parse(getValue);
            var tempCount = 3;
            for (idx = 0; idx < nameValueCol.length; idx++) {
                if (nameValueCol[idx].SearchText != encodeURIComponent(Coveo.$(".body-content .CoveoSearchbox input").val())) {
                    if (idx <= tempCount && nameValueCol[idx].SearchText.toUpperCase() !== Coveo.$(".body-content .CoveoSearchbox input").val().toUpperCase()) {
                        CollectData.push({ SearchText: (nameValueCol[idx].SearchText), SearchUrl: nameValueCol[idx].SearchUrl });
                    }
                } else {
                    tempCount = 4;
                }
            }

            getValue = JSON.stringify(CollectData);
            setCookie(cookiename, getValue, 10);
        }
        else {
            getValue = jsonString;
            setCookie(cookiename, getValue, 10);
        }
    }
    function ToggelLastSearch(cookiename) {
        var acookie = getCookie(cookiename);
        if (!$('.body-content #A05Searchbox_Recentsearch').length) return;
        if (!acookie) {
            $('.body-content #A05Searchbox_Recentsearch').hide();
        }
        else {
            $('.body-content #A05Searchbox_Recentsearch').show();
            $(".body-content #A05Searchbox_Recentsearch span")[0].innerHTML = '';
            var getValue = acookie;
            getValue = getValue.replace("\\", "\\\\");
            var nameValueCol = $.parseJSON(getValue);
            var i = 0;
            var tempsearchText = '';
            var tempsearchUrl = '';
            for (idx = 0; idx < nameValueCol.length; idx++) {
                tempsearchText = decodeURIComponent(nameValueCol[idx].SearchText);
                tempsearchUrl = nameValueCol[idx].SearchUrl;
                var newAnchorTag;
                if ($(".SDS.Search").length || $(".PDS.Search").length) {
                    newAnchorTag = $('<a href="' + tempsearchUrl + '"></a>');
                }
                else {
                    newAnchorTag = $('<a href="' + tempsearchUrl + '#q=' + encodeURIComponent(tempsearchText) + '"></a>');
                }
                if (tempsearchText.indexOf("&127338") > -1) {
                    tempsearchText = tempsearchText.split("&127338").join("&#127338;");
                    newAnchorTag[0].innerHTML = sanitizeHtmlStrings(tempsearchText);
                }
                else {
                    newAnchorTag.text(tempsearchText);
                }

                if (idx > 0) {
                    $(".body-content div#A05Searchbox_Recentsearch span").append(', ', newAnchorTag);
                }
                else {
                    $(".body-content div#A05Searchbox_Recentsearch span").append(newAnchorTag);
                }
            }
        }
    }

    function ToggelSearchSuggestion(searchText) {
        if (searchText == null || searchText == 'undefined') {
            $('div.component.search-suggestions').hide();
        }
        else {
            if ($('div.component.search-suggestions').length == 0) return;
            $('div.component.search-suggestions').find('ul')[0].innerHTML = '';

            var getDataAppSerachconfig = JSON.stringify($("#SearchSuggestion").data("appSearchconfig"));
            var nameValueCol = $.parseJSON(getDataAppSerachconfig);
            var isMatch = false;
            $.each(nameValueCol, function (key, value) {
                var getSearchKey = value.SearchKey.split(' ');
                isMatch = false;
                $.each(getSearchKey, function (index, valuet) {
                    var searchKey = searchText.split('*').join('');
                    if (searchKey.trim().toUpperCase().indexOf(valuet.toUpperCase()) > -1) {
                        $('div.component.search-suggestions').find('ul').append(sanitizeHtmlStrings('<li><a href="' + value.url + '" class="glyph-link-bullet">' + value.SearchValue + '</a></li>'));
                        isMatch = true;
                        return false;
                    }
                });
                if (isMatch) {
                    $('div.component.search-suggestions').show();
                    return false;
                }
            });
            if (!isMatch)
                $('div.component.search-suggestions').hide();
        }
    }
    /******* Coveo last search ends here**********/
    function toggleFacetShowMoreLess() {
        $(".coveo-facet-less,.coveo-facet-more").attr("tabindex", "0");
        //$(".coveo-facet-less,.coveo-facet-more").removeAttr("tabindex");
        $("body").on("click", ".coveo-facet-less,.coveo-facet-more", function (evt) {
            //$(evt.currentTarget).attr("contenteditable", "false");
            //$(".coveo-facet-footer .coveo-active").attr("contenteditable", "true");
            var showMoreOrLess = $(evt.currentTarget).parents(".coveo-facet-footer");
            setTimeout(function () {
                if ($(showMoreOrLess).find(".coveo-facet-more:visible").length) {
                    $(showMoreOrLess).find(".coveo-facet-more").focus();
                    //.attr("contenteditable", "false");
                }
                if ($(showMoreOrLess).find(".coveo-facet-less:visible").length) {
                    $(showMoreOrLess).find(".coveo-facet-less").focus();
                    //.attr("contenteditable", "false");
                }
                addCheckboxRole();
            }, 1300);
        });
    }

    function sanitizeHTML(input) {
        return sanitizeHtmlStrings(input);
    }

    $(window).on('load', setSearchButtonFocus);
    function setSearchButtonFocus() {
        // Bind Enter Event to the button
        var index = 0;
        setTimeout(function () {
            $(".CoveoSearchButton").each(function () {
                $(this).attr("id", "coveosearchbutton" + index);
                $(this).attr("tabindex", "0");
                index++;
            });

            //Change Position of the button
            var coveoSearchButtons = $(".CoveoSearchButton");
            for (var i = 0; i < coveoSearchButtons.length; i++) {
                $(coveoSearchButtons[i]).insertAfter($(coveoSearchButtons[i]).siblings(".CoveoOmnibox.magic-box"));
            }
            $("body").off("keyup", ".CoveoSearchButton");
            $("body").on("keyup", ".CoveoSearchButton", function (event) {
                if (event.keyCode === 13) {
                    event.preventDefault();
                    $(event.currentTarget)[0].click();
                    //$(this).focus();
                }
            });
        }, 2000);
    }

    // FLWEP2-8831 -- facet filter for mobile device
    // we are updating the selected filters tag + removing tags on click along with unchecking them and refreshing the page
    function SelectedFacetFilter() {
        $(".selected_filter").html('');
        var selectedValue = [];

        $(".facetFilter_mainContainer .coveo-facet-values li").each(function () {
            if ($(this).hasClass("coveo-selected")) {
                var val = $(this).attr("data-value");
                if (!selectedValue.includes(val)) {
                    selectedValue.push(val);
                }
            }
        });

        $(".selected_filter").append(
            '<span class="d-none"><i class="fa fa-times remove_selectedFilter" aria-hidden="true" data-val=""></i></span>'
        );
        $(selectedValue).each(function (i, e) {
            $(".selected_filter").append(
                '<span>' + selectedValue[i] + '<i tabindex="0" class="fa fa-times remove_selectedFilter" role="button" aria-label="clear" data-val="' + selectedValue[i] + '"></i></span>'
            );
        });
        $(".remove_selectedFilter").click(function () {
            var text = encodeURI($(this).attr("data-val"));
            if (document.location.href.indexOf(text) > -1) {
                var replaceurl = window.location.href.replace(text, "");
                window.location.href = sanitizeHtmlStrings(replaceurl);
            }
        });
    }

    // accessibility fix for checkbox roles and grouping
    function addCheckboxRole() {
        $(".CoveoFacet").each(function (index) {
            $(this).attr('role', 'group');
            $(this).attr('aria-label', $(this).find(".coveo-facet-header-title").text());
        });
        $(".coveo-facet-value.coveo-facet-selectable:not(.coveo-facet-search-button)").each(function (index) {
            $(this).find(".coveo-facet-value-checkbox").attr("aria-label", $(this).attr('data-value'));
            $(this).find(".coveo-facet-value-checkbox").attr("role", 'checkbox');
            if ($(this).hasClass('coveo-selected')) {
                $(this).find(".coveo-facet-value-checkbox").attr("aria-checked", 'true');
            }
            else { $(this).find(".coveo-facet-value-checkbox").attr("aria-checked", 'false'); }
        });
    }

    // Header for event search event from SC team
    function coveoEventSearch() {
        if ($(".sds-search-result-list > .searchtablecontainer").length == 1 && $(".coveo-result-list-container > .searchtablecontainer").length == 0 && $(".coveo-result-list-container > .coveo-list-layout").length > 0) {
            $(".searchtablecontainer:first").clone().prependTo($('.coveo-list-layout-container'));
        }
        setTimeout(function () {
            if ($(".coveoSearchHeaderRow").length == 1 && $(".coveo-result-list-container > .coveoSearchHeaderRow").length == 0 && $(".coveo-result-list-container > .coveo-list-layout").length > 0) {
                $(".coveoSearchHeaderRow").clone().prependTo($('.coveo-list-layout-container'));
            }
        }, 500);

        var ariaLabelText = $('.sds-search-result-list').attr('aria-label');
        $('.sds-search-result-list').removeAttr('aria-label');
        $('.sds-search-result-list').removeAttr('role');
        $('.coveo-list-layout-container').attr('aria-label', ariaLabelText);
        $('.coveo-list-layout-container').attr('role', "table");

        setTimeout(function () {
            containerElementEmptyIssue();
        }, 2000);

        // To get row and column count
        var searchContainer = $('.searchtablecontainer');
        if ($(searchContainer).length > 0) {
            var cellCount; var rowCount;
            $(searchContainer).each(function (index) {
                cellCount = $(this).find("[role='cell']").length;
                return false;
            });
            if ($('.sds-search-result-list').length === 1) {
                $('.coveo-list-layout-container').attr('aria-colcount', cellCount);
            }
            rowCount = $('.coveo-list-layout-container').children().find("[role='row']").length;
            $('.coveo-list-layout-container').attr('aria-rowcount', rowCount);
        }
    }

    $('.seeallList').on('keypress', function (e) {
        if (e.keyCode === 32 || e.keyCode === 13) {
            $('.seeallList').trigger('click');
        }
    });
    $('.seeLessList').on('keypress', function (e) {
        if (e.keyCode === 32 || e.keyCode === 13) {
            $('.seeLessList').trigger('click');
        }
    });

    $('.custom-date-sort').on('keypress', function (e) {
        if (e.keyCode === 32 || e.keyCode === 13) {
            $(".date-selected-sorting").trigger('click');
        }
    });
    $('.coveo-sort-section .CoveoSort').on('keypress', function (e) {
        if (e.keyCode === 32 || e.keyCode === 13) {
            e.preventDefault();
            $(this).trigger('click');
            setTimeout(function () {
                $('.coveo-dateSort').hide();
            }, 3000);
            //
        }
    });

    function containerElementEmptyIssue() {
        if ($('.coveo-result-list-container').children().length > 0) {
            var displayStyle = $('.CoveoResultList .coveo-result-list-container').css("display");
            if (displayStyle === 'none') {
                $('.CoveoResultList .coveo-result-list-container').css("display", "inherit");
            } else {
                $('.CoveoResultList .coveo-result-list-container').css("display", displayStyle);
            }
        } else {
            $('.CoveoResultList .coveo-result-list-container').css("display", "none");
        }
    }
}(window.jQuery));